import { getAuthErrorDetails, isExtensionTimeout } from '@fjuel/configs/auth';
import { Box, Button, Typography } from '@mui/material';

interface AuthRecoveryNoticeProps {
  error: Error;
  onRetry?: () => void;
  onSignIn?: () => void;
  busy?: boolean;
  compact?: boolean;
}

export const AuthRecoveryNotice = ({ error, onRetry, onSignIn, busy, compact }: AuthRecoveryNoticeProps) => {
  const { code, correlationId } = getAuthErrorDetails(error);

  return (
    <Box
      component="main"
      role="alert"
      data-testid="auth-recovery-notice"
      sx={{
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        minHeight: compact ? undefined : '100dvh',
        p: 4,
      }}
    >
      <Typography component="h1" variant="h4">
        Authentication is unavailable
      </Typography>
      <Typography>
        {isExtensionTimeout(error)
          ? 'The identity provider authentication extension timed out (1003005). Retry later; signing in again may not resolve the provider issue.'
          : 'Authentication could not complete. Retry or sign in again.'}
      </Typography>
      <Typography color="text.secondary">
        Error: {code}
        {correlationId && ` | Correlation: ${correlationId}`}
      </Typography>
      {onRetry && (
        <Button data-testid="auth-recovery-retry-button" disabled={busy} onClick={onRetry}>
          Retry
        </Button>
      )}
      {onSignIn && (
        <Button data-testid="auth-recovery-signin-button" disabled={busy} onClick={onSignIn}>
          Sign in again
        </Button>
      )}
    </Box>
  );
};
